/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogAddressListRequest = {
    page?: number;
    size?: number;
    sortField?: ZerogAddressListRequest.sortField;
    sortDirection?: ZerogAddressListRequest.sortDirection;
};

export namespace ZerogAddressListRequest {

    export enum sortField {
        BALANCE = 'BALANCE',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

